<template>
  <div class="payment-container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'system-admin-resellers'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p style="white-space: nowrap">Back to Resellers</p>
      </div>
    </nav>
    <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header table-header">
            <th>Date</th>
            <th>Company</th>
            <th>Description</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr class="line" v-for="(payment, k) in payments" :key="k">
            <th>{{payment.date}}</th>
            <th>
              <!-- <img class="popup_image" src="@/assets/person.jpg" alt /> -->
              {{payment.companyName}}
            </th>
            <th>{{payment.invoiceNumber}}</th>
            <th class="Invoice_price">${{payment.amount}}</th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="per-page">
      <span class="filter_by custom-row">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="payments.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    showDropDown: false,
    payments: [],
    per_page: 10,
    pages: [10, 50, 100],
    TotalPages: null,
    Searched: "",
    Page: 0,
  }),
  created() {
    this.GetList(this.Searched, this.Page);
  },
  methods: {
    changePerPage() {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList(this.Searched, this.Page);
    },
    GetList(search, page) {
      this.$store
        .dispatch("GetPaymentList", {
          search: search,
          page: page,
          perPage: this.per_page,
          company_uuid: this.$route.params.id,
        })
        .then((res) => {
          console.log("res--->", res);
          this.payments = res.items.map(this.transformPayments);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        invoiceId: i.invoice_uuid,
        invoiceNumber: i.invoice_number,
        createdBy: i.created_by,
        companyName: i.company_name,
        date: format(i.paid_on, "D MMM YYYY"),
        amount: i.amount,
      };
    },
    outside() {
      this.showDropDown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-container {
  padding: 0 20px;

  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    width: 100% !important;
    align-items: center;
    height: 40px;
    float: right;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th {
    text-align: center;
  }
  .table-header th {
    padding-left: 15px;
    border: 1px solid #dee2e6;
    background: #51a3f3;
    color: #fff;
  }
}
table thead tr {
  height: 37px;
  background: #f8f9fe;
  text-align: left;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}
.Invoice_table_header th {
  height: 16px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  vertical-align: middle;
}
table thead th:first-child {
  padding-left: 35px;
}
table th:first-child {
  padding-left: 35px;
}
tbody th.created_by {
  line-height: 20px;
  height: 30px;
  padding: 10px 0 10px 0;
}
tbody th.company_inc {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 0 12px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 12px 0 12px 0;
  color: #000000;
  font-weight: bold;
  line-height: 20px;
}
.Invoice_table_header th.Invoice_header_total {
  padding-left: 40px;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.status:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 20px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 0 0 0 12px;
}

.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

@media screen and (max-width: 1300px) {
  table.Invoice_table {
    width: 1000px;
  }
}
</style>

